import React, { useState, useEffect } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import {
  Input,
  Button,
  Select,
  Typography,
  Tooltip,
  notification,
  Avatar
} from 'antd';
import { Comment } from '@ant-design/compatible';
import api from '../../../../api/api';
import Grocefy from '../../../../assets/images/grocefyLogoAlone.png';

function ForgotPassForm() {
  const { Title } = Typography;
  const { t } = useTranslation();
  const { Option } = Select;
  const [submitting, setSubmitting] = useState(false);
  const [allowSubmit, setAllowSubmit] = useState(false);
  const [data, setData] = useState({
    emailValid: '',
  });

  useEffect(() => {
    if (data) {
      let valid = true;
      valid = valid && data.emailValid === 'warning';
      setAllowSubmit(valid);
    }
  }, [data]);

  const showMessage = function (message) {
    notification.open({
      message: '',
      description: (
        <Comment
          author={<span>Grocefy</span>}
          avatar={<Avatar src={Grocefy} alt="grocefy" />}
          content={
            <p className="text-sm">
              {message}
            </p>
          }
          datetime={
            <Tooltip title={moment().format('YYYY-MM-DD HH:mm:ss')}>
              <span>{moment().fromNow()}</span>
            </Tooltip>
          }
        />
      ),
    });
  };

  const submit = () => {
    setSubmitting(true);
    api
      .post('users/me/reset', data, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        setSubmitting(false);
        if (response.status === 200 && response.data.error) {
          showMessage(response.data.error);
        } else if (response.status === 200) {
          window.location.href = '/';
        }
      })
      .catch((error) => {
        setSubmitting(false);
        showMessage(error.message);
      });
  };

  return (
    <div className="mx-64">
      <Link to="/">
        <FontAwesomeIcon className="mt-4 text-2xl" icon={faArrowLeft} />
      </Link>
      <Title className="mx-2 mt-2">{t('forgot_password')}</Title>
      <div className="grid grid-cols-1">
        <div className="mx-2 mt-4">
          <strong>{t('email')}:</strong>
          <Input
            status={data.emailValid}
            disabled={submitting}
            loading={submitting}
            placeholder={t('email')}
            onChange={(obj) => {
              const pattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(.\w{2,3})+$/;
              setData({
                ...data,
                email: obj.target.value,
                emailValid: obj.target.value.trim().length > 0 && pattern.test(obj.target.value.trim()) ? 'warning' : 'error'
              });
            }}
            value={data.email}
          />
        </div>
      </div>
      <div className="mx-2 mt-4 items-center">
        <Button
          className="w-full"
          loading={submitting}
          disabled={submitting || !allowSubmit}
          onClick={() => submit()}
          type="primary"
        >
          {t('submit')}
        </Button>
      </div>
    </div>
  );
}

export default ForgotPassForm;
